module.exports = __webpack_public_path__ + "assets/48c35f4cd47a09acf4288bc52c84f1bd.png";